module.exports = __webpack_public_path__ + "img/botol-mint-flick.c72ae4c4.png";